import { styled } from 'styled-components';

import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { colors, cssBreakpoints, fontWeights, transition } from '#/theme/theme';

export const PageLink = styled(StyledNativeLinkWithRef)`
  display: flex;
  padding: 4px;
  margin: 0 10px;
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.semiBold};

  &,
  &:active,
  &:visited,
  &:hover {
    text-decoration: none;
  }

  &:hover,
  &:focus {
    color: ${colors.hoverBlue};
  }
`;

export const CurrentPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
  background-color: ${colors.brandBlue};
  border-radius: 50%;
  text-align: center;
  width: 40px;
  height: 40px;
  color: white;
  font-weight: ${fontWeights.semiBold};
`;

export const ArrowLink = styled(StyledNativeLinkWithRef)<{
  $disabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;

  &,
  svg {
    transition: all ${transition};
  }

  svg {
    * {
      fill: ${colors.brandBlue};
    }
  }

  ${(props) =>
    props.$disabled &&
    `
    pointer-events: none;
    svg {
      * {
        fill: ${colors.elementGrey};
      }
    }
  `}
  &:hover,
  &:focus {
    background: ${colors.calloutGrey};

    svg {
      * {
        fill: ${colors.hoverBlue};
      }
    }
  }
`;

export const Pagination_Box_1 = styled.div`
  padding-left: 8px;
  color: ${colors.elementGrey};

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    padding-left: 0;
  }
`;

export const Pagination_Box_2 = styled.div`
  padding-right: 8px;
  color: ${colors.elementGrey};

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    padding-right: 0;
  }
`;

export const Pagination_Box_3 = styled.nav`
  justify-content: center;
  margin-top: 12px;
  display: flex;
  align-items: center;
  flex: 1 1 auto;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

export const Pagination_Box_4 = styled.div`
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Pagination_Hide_1 = styled.div`
  display: block;

  &:where([data-hide-xs]) {
    display: none;
  }

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: block;
  }
`;
